import { Box, BoxProps } from '../Box/index.js';
import React, { ForwardedRef } from 'react';

/**
 * VStack component is a flexbox container component with different props
 * that can handle a set of styling properties with flex-direction: column
 */
export const VStack = React.forwardRef(
  (
    { children, ...rest }: Omit<BoxProps, 'flexDirection'>,
    ref: ForwardedRef<HTMLElement>,
  ) => {
    return (
      <Box {...rest} flexDirection="column" ref={ref}>
        {children}
      </Box>
    );
  },
);

VStack.displayName = 'VStack';

export default VStack;
